import { InboxRulesEditOptionState } from '../../store/schema/InboxRulesEditOptionState';
import { ObservableMap } from 'mobx';

export default function initializeInboxRulesEditState(): InboxRulesEditOptionState {
    return {
        ruleId: '',
        ruleName: '',
        conditionalClauseIds: [],
        actionClauseIds: [],
        exceptionClauseIds: [],
        clauseMap: new ObservableMap(),
        clauseErrorTextMap: new ObservableMap(),
        includesWordsInputTextMap: new ObservableMap(),
        isSectionInfoCalloutVisible: new ObservableMap(),
        focusedClauseId: '',
        ignoreSubsequentRules: true,
        shouldRunRuleNow: false,
        selectedFolderId: '',
        shouldShowMoveToDropdown: true,
    };
}
